  var font = new FontFace('Bebas Neue-Regular', 'url(https://cdn.shopifycdn.net/s/files/1/0737/0578/3585/files/BebasNeue-Regular.ttf?v=1685067499)');
  var font_medium = new FontFace('Poppins-Medium', 'url(https://cdn.shopifycdn.net/s/files/1/0737/0578/3585/files/Poppins-Medium.ttf?v=1685346178)')
  var font_light = new FontFace('Poppins-Light', 'url(https://cdn.shopifycdn.net/s/files/1/0737/0578/3585/files/Poppins-Light.ttf?v=1685346178)')
  var font_SemiBold = new FontFace('Poppins-SemiBold', 'url(https://cdn.shopifycdn.net/s/files/1/0737/0578/3585/files/Poppins-SemiBold.ttf?v=1685346178)')
  font.load().then(function(loadedFont) {
    document.fonts.add(loadedFont);
    console.log('Font loaded successfully');
  }).catch(function(error) {
    console.log('Font failed to load: ' + error);
  });
  font_medium.load().then(function(loadedFont) {
    document.fonts.add(loadedFont);
  }).catch(function(error) {
  })
  font_light.load().then(function(loadedFont) {
    document.fonts.add(loadedFont);
  }).catch(function(error) {
  })
  font_SemiBold.load().then(function(loadedFont) {
    document.fonts.add(loadedFont);
  }).catch(function(error) {
  })